import Message from './Message';
import ToolTip from 'components/ToolTip';
import { Mixpanel } from 'utilities/mixpanel';

export default ({
  error,
  submitAttempted,
  toolTip,
  dataEvent,
  dataFor,
  marginLeft,
  className,
  iconName
}) => {
  let classes = `${
    error.type == 'none' || submitAttempted == false ? 'is-hidden' : ''
  } ${className}`;

  if (error.text && typeof error.text === 'string') {
    if (error.text.includes('to be less than')) {
      Mixpanel.track('Declined', {
        Value: 'Vehicle Under $2000',
        Vehicle: error.vehicleDescription ? error.vehicleDescription : ''
      });
      Mixpanel.people.increment('Vehicle Quote Declines');
    }
    if (error.text.includes('manufactured before 1980')) {
      Mixpanel.track('Declined', {
        Value: 'Pre 1980 Vehicle',
        Vehicle: error.vehicleDescription ? error.vehicleDescription : ''
      });
      Mixpanel.people.increment('Vehicle Quote Declines');
    }
    if (error.text.includes('high performance vehicle')) {
      Mixpanel.track('Declined', {
        Value: 'High Performance Vehicle',
        Vehicle: error.vehicleDescription ? error.vehicleDescription : ''
      });
      Mixpanel.people.increment('Vehicle Quote Declines');
    }
    if (error.text.includes("Looks like we can't cover your class of vehicle")) {
      Mixpanel.track('Declined', {
        Value: '3 Seater Van',
        Vehicle: error.vehicleDescription ? error.vehicleDescription : ''
      });
      Mixpanel.people.increment('Vehicle Quote Declines');
    }
    if (error.text.includes('over 3,500kg')) {
      Mixpanel.track('Declined', {
        Value: 'Vehicle Over 3,500KG',
        Vehicle: error.vehicleDescription ? error.vehicleDescription : ''
      });
      Mixpanel.people.increment('Vehicle Quote Declines');
    }
    if (error.text.includes('to be greater than')) {
      Mixpanel.track('Declined', {
        Value: 'Exceeds Max Vehicle Value',
        Vehicle: error.vehicleDescription ? error.vehicleDescription : '',
        Car_Value: error.vehicleValue ? error.vehicleValue : ''
      });
      Mixpanel.people.increment('Vehicle Quote Declines');
    }
    if (error.text.includes('special make model')) {
      Mixpanel.track('Declined', {
        Value: 'Special Make/Model Vehicle',
        Vehicle: error.vehicleDescription ? error.vehicleDescription : ''
      });
      Mixpanel.people.increment('Vehicle Quote Declines');
    }
    if (error.text.includes('ride sharing or similar')) {
      Mixpanel.track('Declined', {
        Value: 'Uber/Certificate of Fitness',
        Vehicle: error.vehicleDescription ? error.vehicleDescription : ''
      });
      Mixpanel.people.increment('Vehicle Quote Declines');
    }
    if (error.text.includes('WOF expired')) {
      Mixpanel.track('Declined', {
        Value: 'Expired WOF ',
        Vehicle: error.vehicleDescription ? error.vehicleDescription : ''
      });
      Mixpanel.people.increment('Vehicle Quote Declines');
    }
    if (error.text.includes('Rego expired')) {
      Mixpanel.track('Declined', {
        Value: 'Expired Rego ',
        Vehicle: error.vehicleDescription ? error.vehicleDescription : ''
      });
      Mixpanel.people.increment('Vehicle Quote Declines');
    }
    if (error.text.includes("Sorry but we can't insure you at this time")) {
      Mixpanel.track('Declined', { Value: 'Excessive Device Incidents' });
      Mixpanel.people.increment('Declined Quote (Item)');
    }
  }

  return (
    <>
      <Message marginLeft={marginLeft} id="error" className={classes}>
        {iconName && (
          <div className="icon-container">
            <i className={iconName} style={{ color: '#15847d' }} />
            {error.title && (
              <h3>
                <strong>{error.title}</strong>
              </h3>
            )}
          </div>
        )}
        {error.text}{' '}
        {toolTip ? (
          <ToolTip
            dataTip={toolTip}
            dataEvent={dataEvent}
            dataFor={dataFor || 'error'}
            dataMultiline={true}
            effect="solid"
          />
        ) : null}
      </Message>
      <style jsx="true">{`
        .icon-container {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 0px;
          gap: 10px;
          flex: none;
          order: 0;
          flex-grow: 0;
        }
      `}</style>
    </>
  );
};
